import {createUseStyles} from 'react-jss';
import VideoNotSupportedImg from '../../../src/images/video-player/video-not-supported.svg';

export const useStyles = createUseStyles({
  videoProcessingStub: {
    position: 'relative',
    paddingTop: '56.25%',
    '& > img': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%'
    }
  },
  videoNotSupportedStub: {
    paddingTop: 22,
    paddingRight: 32,
    paddingBottom: 16,
    paddingLeft: 32,
    backgroundColor: '#F0F2F4',
    '& > span': {
      fontSize: 14,
      lineHeight: 1.2,
      fontWeight: 700,
      color: '#818699',
      textAlign: 'center',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      position: 'absolute',
      left: 0,
      top: 0,
      width: '100%',
      height: '100%',
      '@media (min-width: 601px) and (max-width: 767px)': {
        fontSize: 0
      },
      '&:before': {
        content: '""',
        display: 'block',
        background: `url(${VideoNotSupportedImg}) no-repeat`,
        backgroundPosition: 'center',
        backgroundSize: 'contain',
        width: 225,
        height: 95,
        marginBottom: 24,
        '@media (min-width: 601px) and (max-width: 767px)': {
          marginBottom: 0
        }
      }
    }
  }
});
